Ext.define('SA.data.UserItemList', {
    mixins: {
        observable: 'Ext.util.Observable'
    },

    constructor(cfg) {
        this.mixins.observable.constructor.call(this, cfg);

        this.requests = [];
        this.initialCachePending = true;
    },

    add(ids) {
        if (!this.all) {
            return; 
        }

        var all = this.all,
            limit = this.limit,
            add = [],
            update = [],
            requests = this.requests,
            remove;

        if (!Array.isArray(ids)) {
            ids = [ids];
        }

        if (limit && ids.length > limit) {
            ids = ids.slice(-limit);
        }

        ids.forEach(id => {
            id = this.getId(id);

            var index = this.indexOf(id),
                data = this.toData(id);

            if (index === -1) {
                add.push(data);
            }
            else {
                data.timestamp = true;

                update.push(data);

                all.splice(index, 1);
            }

            all.unshift(Ext.applyIf({timestamp: new Date() / 1000}, data));
        });

        if (limit && all.length > limit) {
            remove = Ext.Array.pluck(all.slice(limit), 'id');

            all.length = limit;
        }

        if (remove) {
            requests.push({
                data: remove,
                method: 'delete'
            });
        }

        if (add.length) {
            requests.push({
                data: add,
                method: 'create'
            });
        }

        if (update.length) {
            requests.push({
                data: update,
                method: 'update'
            });
        }

        this.processRequestQueue();

        if (add.length > 0 || remove !== undefined) {
            let toggled = add.map(({id}) => id).concat(Ext.Array.from(remove));

            this.fireEvent('toggle', toggled);
        }

        this.fireEvent('change');
    },

    async afterLoadAll() {
        await this.ensureCached();

        this.initialCachePending = false;

        this.fireEvent('change');
    },

    contains(id) {
        return this.indexOf(id) !== -1;
    },

    getId(item) {
        if (typeof item === 'object') {
            return item.id;
        }

        return item;
    },

    getIds() {
        return Ext.Array.pluck(this.all || [], 'id');
    },

    idsEqual(id1, id2) {
        return id1 === id2;
    },

    indexOf(id) {
        id = this.getId(id);

        return this.all.findIndex(item => this.idsEqual(item.id, id));
    },

    loadAll() {
        if (this.limit === 0) {
            SA.Ajax.request({
                method: 'getLimit',
                resource: this.resource,

                success: limit => {
                    this.limit = limit;
                }
            });
        }

        return SA.Ajax.request({resource: this.resource})
            .then(items => {
                this.all = items.sort((a, b) => b.timestamp - a.timestamp);

                this.afterLoadAll();
            });
    },

    processRequestQueue() {
        var requests = this.requests,
            request;

        if (this.saving || requests.length === 0) {
            return;
        }

        this.saving = true;

        request = requests.shift();

        SA.Ajax.request(Object.assign({}, request, {
            resource: this.resource,

            callback: () => {
                this.saving = false;

                this.processRequestQueue();

                Ext.callback(request.callback);
            }
        }));
    },

    remove(ids) {
        var all = this.all,
            index, promise;

        if (!Array.isArray(ids)) {
            ids = [ids];
        }

        ids = ids.map(this.getId);

        ids.forEach(id => {
            index = this.indexOf(id);

            all.splice(index, 1);
        });

        promise = new Promise(resolve => {
            this.requests.push({
                data: ids,
                method: 'delete',
                callback: resolve
            });
        });

        this.processRequestQueue();

        this.fireEvent('toggle', ids);
        this.fireEvent('change');

        return promise;
    },

    toData(id) {
        return {id};
    },

    toggle(id) {
        var method = !this.contains(id) ? 'add' : 'remove';

        this[method](id);
    }
});
